import '@ssml-editor/core';
import { icon, wrapper, markWrapper, markText, text, EditorUtils, NodeUtils, createParagraph } from '@ssml-editor/vue';
import '../phoneme/alphabet.enum.js';
import '../say-as/say-as-interpretation.enum.js';
import { AudioPlayerSingleton } from '@ssml-editor/modules';
import './effect.enum.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                                      */
import 'cmu-pronouncing-dictionary';
/* empty css                                          */
import { markClickHandler } from '../../toolbar-menu/menu.method.js';
/* empty css                                        */
import '../../toolbar-menu/say-as/constant.js';
/* empty css                                        */
import '@element-plus/icons-vue';
/* empty css                                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                                       */
/* empty css                                         */
/* empty css                                     */
/* empty css                                                  */
/* empty css                                             */
/* empty css                                         */
import '../../toolbar-menu/voice/voice-menu.vue.js';
import styles from './render-element.module.css.js';

function createParagraphByElement(element) {
  const textElement = {
    text: NodeUtils.getText(element)
  };
  return createParagraph([textElement]);
}
function replaceNode(editor, node) {
  const targetNode = createParagraphByElement(node);
  EditorUtils.replaceNode(editor, node, targetNode);
}
const speakRenderElement = ({
  element,
  children,
  attributes,
  editor
}) => {
  const node = element;
  const mark = node.bgmName ? `${node.bgmName}-v${node.bgmVolume} | ${node.mark}` : node.mark;
  const iconNodes = [
    icon(
      null,
      ["iconfont-ssml-editor", "icon-ssml-editor-close-fill"],
      void 0,
      {
        onClick: (event) => {
          event.stopPropagation();
          AudioPlayerSingleton.stop().unload();
          replaceNode(editor, node);
        }
      }
    )
  ];
  if (node.bgm) {
    iconNodes.push(
      icon(
        null,
        ["iconfont-ssml-editor", "icon-ssml-editor-bofang"],
        void 0,
        {
          onClick: (event) => {
            event.stopPropagation();
            AudioPlayerSingleton.play({ src: node.bgm });
          }
        }
      )
    );
    iconNodes.push(
      icon(
        null,
        ["iconfont-ssml-editor", "icon-ssml-editor-zanting"],
        void 0,
        {
          onClick: (event) => {
            event.stopPropagation();
            AudioPlayerSingleton.pause();
          }
        }
      )
    );
  }
  return wrapper(
    "div",
    attributes,
    markWrapper(
      iconNodes,
      markText(mark),
      void 0,
      {
        "background-color": "var(--cosy-voice-speak)"
      },
      {
        onClick: (event) => {
          event.stopPropagation();
          markClickHandler(editor, node);
        }
      }
    ),
    text(children, [styles.seSpeakText], void 0, void 0, {
      color: "var(--cosy-voice-speak)"
    })
  );
};

export { speakRenderElement };
//# sourceMappingURL=render-element.js.map
